import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";


class Slider {
  constructor() {
    this.slider();
  }

  slider() {
    const el = document.querySelector(".slider__container");
    if (!el) return;
    new Swiper(".slider__container", {
      modules: [Navigation, Pagination, Autoplay],
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}

export default Slider;
